import _ from 'lodash'
import { RDegreJourUnifie_Type } from '@batical/types/src'
import { fetchGeneric } from './GenericQ'
const RDJU: Array<RDegreJourUnifie_Type> = require('../json/DJU.json')

//DJU
export function fetchDegreJourUnifie(uuid: string): RDegreJourUnifie_Type {
  return fetchGeneric(RDJU, uuid)
}

export function fetchDegreJourUnifieSorted(): Array<{
  value: string
  label: string
  children: Array<{ value: string; label: string }>
}> {
  let data: Array<{
    value: string
    label: string
    children: Array<{ value: string; label: string }>
  }> = []
  const result = _.sortBy(RDJU, ['annee'])
  let filtered = Array.from(result.reduce((m, t) => m.set(t.annee, t), new Map()).values())
  filtered.map((item: RDegreJourUnifie_Type) => {
    let res2 = _.sortBy(
      RDJU.filter((item2: RDegreJourUnifie_Type) => item.annee === item2.annee),
      ['name']
    )

    let dataMat: Array<{ value: string; label: string }> = []
    res2.map((item2: RDegreJourUnifie_Type) => {
      dataMat.push({ value: item2.uuid, label: item2.name })
    })
    data.push({ value: item.annee, label: item.annee, children: dataMat })
  })
  return data
}
